import React, {useState} from 'react';
import {ModalWrapper} from "../../components/ModalWrapper";
import {useFormik} from "formik";
import {createUser, showErrorToast, showSuccessToast} from "../../helpers";
import * as Yup from "yup";
import {regExpPassword} from "../../constants";
import {MDBBtn, MDBCheckbox, MDBCol, MDBIcon, MDBInput, MDBRow} from "mdb-react-ui-kit";

const CreateUserModal = ({isOpen, onClose}) => {
    const [isCreating, setIsCreating] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object().shape({
            email: Yup.string().email('Invalid email').required('Email is required'),
            password: Yup.string()
                .matches(regExpPassword,
                    'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character, and be at least 8 characters long'
                ).required('Password is required'),
        }),
        onSubmit: async (values) => {
            try {
                setIsCreating(true);
                const userToCreate = {
                    email: values.email?.toLowerCase(),
                    password: values.password,
                };

                await createUser(userToCreate);
                window.location.reload();
            } catch (error) {
                onClose();
                showErrorToast('Could not create user');
            } finally {
                setIsCreating(false);
            }
        },
    });

    return (
        <ModalWrapper
            title={'Create a new user'}
            isOpen={isOpen}
            onClose={() => onClose()}
            modalClassSize={'modal-md'}
        >
            <form
                onSubmit={async (e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                }}
            >
                <MDBRow>
                    <MDBCol>
                        <MDBInput
                            label="Email"
                            id="email"
                            type="email"
                            {...formik.getFieldProps('email')}
                        />
                        {formik.touched.email && formik.errors.email ? (
                            <div className="text-danger">{formik.errors.email}</div>
                        ) : null}
                    </MDBCol>
                </MDBRow>
                <MDBRow className="mt-3">
                    <MDBCol>
                        <MDBInput
                            label="Password"
                            id="password"
                            type="password"
                            {...formik?.getFieldProps('password')}
                            autoComplete="new-password"
                        />
                        {formik?.errors?.password ? (
                            <div className="text-danger">{formik?.errors?.password}</div>
                        ) : null}
                    </MDBCol>
                </MDBRow>
                <div className="mt-3 d-flex justify-content-center">
                    <MDBBtn color={'success'} disabled={isCreating}>
                        {isCreating && <MDBIcon icon='fas fa-solid fa-spinner fa-spin' className='me-3' size='xl'/>}
                        SUBMIT
                    </MDBBtn>
                </div>
            </form>
        </ModalWrapper>
    );
};

export default CreateUserModal;
